// Configuração da API
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '/sysconect' : 'http://localhost:4460/sysconect');

export const API_URL = API_BASE_URL;

// export default removido para evitar export anônimo (não usado)

